import axios from "./axios";
import { excludingPromangStockReportGuideTemplates } from "../utils/promangStockReportGuide";

export async function fetchReportGuideTemplates(params = {}) {
  return axios
    .get("/report_guides/templates", { params })
    .then((res) => res?.data?.data ?? [])
    .catch(() => []);
}

export async function fetchActiveReportGuideTemplate(reportTypeId, purpose = "field_report") {
  const templates = excludingPromangStockReportGuideTemplates(
    await fetchReportGuideTemplates({
      report_type_id: reportTypeId,
      purpose,
    })
  );
  return Array.isArray(templates) ? templates[0] ?? null : null;
}

export async function createReportGuideTemplate(payload) {
  return axios
    .post("/report_guides/templates", { report_guide_template: payload })
    .then((res) => res?.data?.data ?? res?.data)
    .catch((err) => err?.response?.data);
}

export async function updateReportGuideTemplate(id, payload) {
  return axios
    .put(`/report_guides/templates/${id}`, { report_guide_template: payload })
    .then((res) => res?.data?.data ?? res?.data)
    .catch((err) => err?.response?.data);
}

export async function createReportGuideRun(reportId, payload, options = {}) {
  const params = {};
  if (options?.fields) params.fields = options.fields;

  return axios
    .post(`/service/reports/${reportId}/guide_runs`, { report_guide_run: payload }, { params })
    .then((res) => res?.data)
    .catch((err) => err?.response?.data);
}

export async function fetchReportGuideRuns(reportId) {
  if (!reportId) return [];

  return axios
    .get(`/service/reports/${reportId}/guide_runs`)
    .then((res) => res?.data?.data ?? [])
    .catch(() => []);
}
